export const addOrDeleteItemInSet = <T>(set: Set<T>, item: T): Set<T> => {
  const newState = new Set(set);
  set.has(item) ? newState.delete(item) : newState.add(item);
  return newState;
};
